import React, {
    createContext,
    useContext,
    useEffect,
    useMemo,
    useState,
} from 'react';

import { CommunicationContext } from 'utility/Provide/Context/PageContext';

import { InternalOutputActions, InternalOutputState } from './types';

export const InternalOutputContext = createContext<InternalOutputState>({
    showInternalOutput: false,
});

export const InternalOutputActionContext = createContext<InternalOutputActions>(
    {
        setTransactionId() {},
    }
);

export const InternalOutputProvider: React.FC<React.PropsWithChildren> = ({
    children,
}) => {
    const [showInternalOutput, setShowInternalOutput] = useState(false);
    const [transactionId, setTransactionId] = useState<string>();
    const { react } = useContext(CommunicationContext);
    const contextState = useMemo<InternalOutputState>(
        () => ({
            showInternalOutput,
            transactionId,
        }),
        [showInternalOutput, transactionId]
    );

    const actions = useMemo<InternalOutputActions>(
        () => ({
            setTransactionId,
        }),
        []
    );

    useEffect(() => {
        react.bind('setInternalOutputVisible', setShowInternalOutput);

        return () => {
            react.unbind('setInternalOutputVisible');
        };
    }, [react]);

    return (
        <InternalOutputActionContext.Provider value={actions}>
            <InternalOutputContext.Provider value={contextState}>
                {children}
            </InternalOutputContext.Provider>
        </InternalOutputActionContext.Provider>
    );
};
